import {
  type ConfirmPaymentInput,
  type SweetpassCheckoutMachineInput,
} from './sweetpass-checkout.machine.types';

// ─────────────────────────────────────────────────────────────────────────────

export const getConfirmPaymentInput: SweetpassCheckoutMachineInput<ConfirmPaymentInput> = (
  args,
) => {
  const { sweetpassId, amount, confirmStripe, stripeConfirmHandlerRef } = args.context;

  return { sweetpassId, amount, confirmStripe, stripeConfirmHandlerRef };
};
